function toggleMenu() {
  const menuToggle = document.querySelector('#menuToggle')

  if (menuToggle) {
    const siteWrapper = document.querySelector('#site')

    menuToggle.addEventListener('click', () => {
      siteWrapper.classList.toggle('site--moved')
      siteWrapper.classList.toggle('hidden')
    })
  }
}

export default toggleMenu
